let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("avAdJ")).then(() => parcelRequire('6866P'));